import { useEffect, useLayoutEffect, useMemo, useState } from 'react';
import {
  Dimensions,
  Image,
  Modal,
  Platform,
  TouchableOpacity,
  View,
  StatusBar,
  SafeAreaView,
  Linking,
} from 'react-native';
import {
  Icon,
  Space,
  Stack,
  Typography,
  WidgetRegistry,
} from '@voltmoney/component';
import {
  getParameters,
  getScreenType,
  MicroFrontend,
  navigateWithReset,
} from '@voltmoney/platform';
import {
  clearAllData,
  ROUTE,
  isIframe as isFrm,
  ROUTE_MAP,
  BUILD_TYPE,
} from '@voltmoney/micro-frontend';
import ThemeProvider, { THEMES } from '@voltmoney/theme';
import { SCREEN_SIZE } from '@voltmoney/types';
import {
  ColorTokens,
  FontFamilyTokens,
  FontSizeTokens,
  IconSizeTokens,
  IconTokens,
  SizeTypeTokens,
  StackType,
  StackWidth,
  TextAlignTokens,
} from '@voltmoney/schema';
import _ from 'lodash';
import { gapi } from 'gapi-script';
import CodePush from 'react-native-code-push';
import { track } from '@amplitude/analytics-react-native';
import { getBuildType } from '@voltmoney/micro-frontend';
import NewApp from './src/App';

const googleClientIdWeb =
  '62646021413-queb1g13go0snvnotl0ee06t68jcgb98.apps.googleusercontent.com'; //new
// '85274716805-4c9hnt3nm3ntslg72ojt79ubnfkmp9lf.apps.googleusercontent.com'; //old
import { GoogleSignin } from '@react-native-google-signin/google-signin';
import { GoogleKeys } from './google.keys';

import * as Sentry from '@sentry/react-native';
import PageNotFound from './PageNotFound';
import { fetchAndActivate, getAll, getBoolean } from 'firebase/remote-config';
import { getValue } from 'firebase/remote-config';
import { firebaseInit } from './utils';
import { initializeFirebase } from '@voltmoney/micro-frontend/lib/configs/config';
import LogOutUser from './src/helper/logout';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { useAppDispatch, useAppSelector } from '@app/store/hooks';
import { updateFirebaseParams } from '@app/store/slices/firebaseParamsSlice';
import { isFromTDLPlatform, setUserProperty } from '@app/utils';
import useIsOnScreenKeyboardOpen from '@app/hooks/useKeyboardIOS';
import { PLATFORM_NAME } from '@app/types/regix';
import { baseUrl, baseUrlConfig } from '@app/api/apis';

Sentry.init({
  dsn: 'https://5f01f31b9f814dcabada5a2dd5b922cb@o4504883868008448.ingest.sentry.io/4504883869908992',
});

let accessToken = '';
let isNewArch = false;

const SDK_INVESTWELL = 'SDK_INVESTWELL';
const REDVISION = 'REDVISION';
const FREO = 'FREO';
const JUPITER = 'JUPITER';
const NIYO = 'NIYO';

if (Platform.OS !== 'web') {
  GoogleSignin.configure({
    webClientId: GoogleKeys.androidClientId,
  });
}

const AppWeb = ({startWithOldArch = false} : {startWithOldArch?: boolean}) => {
  const dispatch = useAppDispatch()
  const [isUserLoggedIn, setIsUserLoggedIn] = useState(false);
  const [applicationState, setApplicationState] = useState('');
  const [name, setName] = useState('');
  const windowX = Dimensions.get('window');
  const screenX = Dimensions.get('screen');
  const [boxHeight, setBoxHeight] = useState(null);
  const [heightChanged, setHeightChanged] = useState(false);
  const [customerContactNumber, setCustomerContactNumber] = useState('');
  const [
    contactSupportNumberPreDashboard,
    setContactSupportNumberPreDashboard,
  ] = useState('');
  const [finalContactSupportNumber, setFinalContactSupportNumber] =
    useState('');
  const [whatsAppSupportNumber, setWhatsAppSupportNumber] = useState('');
  const [showSupportPhoneNumber, setShowSupportPhoneNumber] = useState(false);
  const phoneNumber = useAppSelector(state => state.commonReducer.phoneNumber);
  const showCallSupport = useAppSelector(state => state?.platformParams?.showCall);

  useLayoutEffect(() => {
    window.addEventListener('message', event => {
      if (event?.data?.id === 'getDimensionLeads') {
        setBoxHeight(event?.data?.data?.height);
        setHeightChanged(!heightChanged);
      }
    });
  }, []);

  const callFirebase = async () => {
    await initializeFirebase();
  };

  const {isOpen : isKeyboardVisible, keyboardHeight}  = useIsOnScreenKeyboardOpen();

  const [routingSupport, setRoutingSupport] = useState({
    renderNewArch: startWithOldArch,
    routeName: '',
    params: {},
  });

  useEffect(() => {
    callFirebase();
    window?.addEventListener('popstate', () => {
      window?.history.back();
    });
  }, []);


  useEffect(() => {
    //@ts-ignore
    const fullName = isUserLoggedIn?.user?.fullName;

    if (fullName) {
      setName(fullName);
    } else {
      setName('');
      isTokenPresent();
    }
    if((routingSupport.renderNewArch) && (phoneNumber || showCallSupport)){
      setShowSupportPhoneNumber(true)
     }
  }, [isUserLoggedIn,phoneNumber, routingSupport.renderNewArch , showCallSupport]);

  useEffect(() => {
    if (applicationState === 'COMPLETED') {
      setFinalContactSupportNumber(customerContactNumber);
    } else {
      setFinalContactSupportNumber(contactSupportNumberPreDashboard);
    }
  }, [
    applicationState,
    contactSupportNumberPreDashboard,
    customerContactNumber,
    finalContactSupportNumber,
  ]);

  const loadFont = () => {
        const fontUrl = 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/simonsonBold.otf';
        const fontFace = new FontFace('MyCustomFont', `url(${fontUrl})`);

        const interSimonson = 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/simonsonRegular.otf'
        const interSimonsonFontFace = new FontFace('InterSimonson', `url(${interSimonson})`);

        fontFace.load().then((loadedFontFace) => {
            document.fonts.add(loadedFontFace);
        }).catch((error) => {
            console.error('Failed to load font:', error);
        });
        interSimonsonFontFace.load().then((loadedFontFace) => {
            document.fonts.add(loadedFontFace);
        }).catch((error) => {
            console.error('Failed to load font:', error);
        });
    };




  useEffect(() => {

    
    // @ts-ignore
    if (Platform.OS === 'web') {
      const remoteConfig = firebaseInit();
      async function fetchRemoteConfig() {
        try {
          await fetchAndActivate(remoteConfig);
          const val = getValue(remoteConfig, 'contact_support_number');
          const allConfigs = getAll(remoteConfig);
          const outputObject = {};
          for (const [key, value] of Object.entries(allConfigs)) {
            //@ts-ignore
            outputObject[key] = value._value;
          }
          console.log('outputObject', outputObject);
          dispatch(updateFirebaseParams(outputObject));
          
          const contactSupportNumberPreDashboard = getValue(
            remoteConfig,
            'contact_support_number_pre_dashboard',
          );
          const contactWhatsAppNumber = getValue(
            remoteConfig,
            'contact_support_number_whatsapp',
          );
          let newArchConfig = false;
          if(getBuildType() === BUILD_TYPE.BORROWER_PRODUCTION){
            newArchConfig = getBoolean(
              remoteConfig,
              'show_new_arch',
            );
          } else{
            newArchConfig = getBoolean(
              remoteConfig,
              'show_new_arch_dev',
            );
          }
          isNewArch = newArchConfig;
          
          // setRoutingSupport({
          //   renderNewArch : newArchConfig,
          //   routeName : '',
          //   params : {}
          // })
          // if(Platform.OS==="web"){
          //   const params = getParameters(window.location.href ) 
          //   const isPLJ = params?.plj;
          //   newArchConfig = Boolean(isPLJ) ? false : newArchConfig;
          // }

          await AsyncStorage.setItem('show_new_arch' , `${newArchConfig}`)
          //@ts-ignore
          setCustomerContactNumber(val._value);
          //@ts-ignore
          setWhatsAppSupportNumber(contactWhatsAppNumber._value);
          //@ts-ignore
          setContactSupportNumberPreDashboard(
            contactSupportNumberPreDashboard._value,
          );
        } catch (error) {
          console.error('Error fetching and activating remote config:', error);
        }
      }
      fetchRemoteConfig();
    }
    if(isFromTDLPlatform()){
      loadFont()
    }
  }, []);

  useEffect(() => {
    CodePush.sync(
      { installMode: CodePush.InstallMode.IMMEDIATE },
      syncWithCodePush,
    );

    if (Platform.OS === 'web') {
      const initClient = () => {
        gapi.client.init({
          clientId: GoogleKeys.webClientId,
          scope: '',
        });
      };
      gapi.load('client:auth2', initClient);
    }
  }, []);

  const syncWithCodePush = (status: any) => {
    console.log('Codepush sync status', status);
  };

  const [dimensions, setDimensions] = useState({
    window: windowX,
    screen: screenX,
  });

  useEffect(() => {
    const subscription = Dimensions.addEventListener(
      'change',
      ({ window, screen }) => {
        dimensions.window = window;
        dimensions.screen = screen;
        setDimensions({
          ...dimensions,
        });
      },
    );
    return () => subscription?.remove();
  }, [dimensions]);

  const  remoteConfig  = firebaseInit();

  
  const checkLMSRevampFlag = (param) => {
    const lmsRevampConfig = getBoolean(
      remoteConfig,
      'show_lms_revamp',
    );
    console.log('LMSREVAMPCONFIG', lmsRevampConfig,param);
    return !lmsRevampConfig ? param : false;
  }
  /*** check if AppBar has to be shown or not ***/
  let showHeader: boolean = true;
  const url = Platform.OS === 'web' ? window.location.href : '';
  /*** get params for custom api header if present in url
   *** example, voltmoney.in/partnerplatform?platform=VOLT_MOBILE_APP
   *  example 2, https://app.staging.voltmoney.in/partnerplatform?platform=SDK_INVESTWELL&primaryColor=03C988
   * ****/

   

 


  const isPartnerPlatform = url.toLowerCase().includes('partnerplatform');
  const isPlatform = url.includes('platform');
  const params = Platform.OS === 'web' ? getParameters(url) : {};
  const sdkParams = Platform.OS === 'web' ? parseParameters(url) : {};
  const platform = params?.platform;
  const primaryColor = params?.primaryColor;
  const secondaryColor = params?.secondaryColor;
  const isPLJ = params?.plj;
  const isPgCallback = checkLMSRevampFlag(params?.uid || '');
  const shouldRedirect = params?.redirect;
  const skipToStep = params?.sts;
  const isFreo = platform === 'FREO' ? true : false;
  const isMarketing = url.toLowerCase().includes('marketing');
  const isKYCRedirect = url.includes('bajajKyc');
  const isIframe = params?.isIframe;
  const showLogout: boolean = !!document.cookie.includes('access_token');
  // params?.showLogout
  //   ? JSON.parse(params?.showLogout)
  //   : true;
  const ssoToken = params?.ssoToken;
  const isCheckLimitMFC = params?.isCheckLimitMFC ? true : false;
  const hideSKDIntroPage = params?.hideSKDIntroPage ? true : false;

  const showVoltDefaultHeader = params?.showVoltDefaultHeader;
  const showDefaultVoltLogo = params?.showVoltLogo;
  const isFromNativeSDK = params?.isFromNativeSDK;
  // @ts-ignore
  const customLogoUrl = sdkParams?.customLogoUrl;
  const cutomerSupportNumber = params?.customSupportNumber;
  const kyc_response = params?.kyc_response;
  const digio_autopay_response = params?.digio_autopay_response;
  const digio_agreement_response = params?.digio_agreement_response;
  const tataMandateCallback = url.toString().includes('mandateCallback');
  const takeToFlexiPay = checkLMSRevampFlag(params?.showFlexi);
  const isCgtc = params?.isCgtc;
  const isProd = baseUrl === baseUrlConfig['production'];
  
  const losRevampConfig = getBoolean(
    remoteConfig,
    isProd ? 'los_revamp' : 'los_revamp_staging',
  ) && platform !== PLATFORM_NAME.TDL ? true : false;

  useEffect(()=>{
    if(losRevampConfig){
      setUserProperty('isLosRevamp', true)
    } else {
      setUserProperty('isLosRevamp', false)
    }
  },[losRevampConfig])


  // if (getBuildType() !== BUILD_TYPE.BORROWER_PRODUCTION) {
  //     if (url?.includes("digilocker_referesh")) {
  //         if (!accessToken) {
  //             console.warn("BVH insiddeeeee condition 345678")
  //             window.location.href = "http://test.staging.voltmoney.in/digilocker_refreshed"
  //         } else {
  //             console.warn('BVH inside condition 22')
  //             window.location.href = "http://app.staging.voltmoney.in/digilocker_refreshed"
  //         }
  //     }
  // }

  /*** Init Theme with customised colors if present in url ***/
  ThemeProvider.init(
    THEMES.LIGHT_MOBILE,
    primaryColor ? `#${primaryColor}` : undefined,
    secondaryColor ? `#${secondaryColor}` : undefined,
  );
  /*** reject this change if default platform is VOLT_MOBILE_APP ***/
  if (isPartnerPlatform && isPlatform) {
    switch (platform) {
      case SDK_INVESTWELL:
        showHeader = true;
        break;
      case REDVISION:
        showHeader = false;
        break;
      case JUPITER:
        showHeader = false;
        break;

      default:
        showHeader = true;
        break;
    }
  } else if (isMarketing || isIframe) {
    showHeader = false;
  } else {
    showHeader = true;
  }

  if (showVoltDefaultHeader === 'false') {
    showHeader = false;
  }

  const [token, setToken] = useState('');
  const [modalVisible, setModalVisible] = useState(false);
  


  const isTokenPresent = async () => {
    const access_token = await getTokenFromCookie();
    setToken(access_token ? access_token : '');
    accessToken = access_token ? access_token : '';
  };

  const getTokenFromCookie = () => {
    const cookies = document.cookie.split(';');
    for (let cookie of cookies) {
      const [name, value] = cookie.trim().split('=');
      if (name === 'access_token') {
        return value;
      }
    }
  };


  function parseParameters(url: string) {
    const params = {};
    const paramStr = url.slice(url.indexOf('?') + 1);

    paramStr.split('&').forEach(param => {
      const [key, value] = param.split('=');
      // @ts-ignore
      params[key] = decodeURIComponent(value);
    });

    return params;
  }

  const toggleModal = () => {
    setModalVisible(!modalVisible);
    setShowSupportPhoneNumber(false);
  };

  const timer = setInterval(() => {
    if (accessToken) {
      clearInterval(timer);
    } else {
      isTokenPresent();
    }
  }, 100);

  const getContactNumberForCall = (platformName: string) => {
    if (platformName === 'FREO') {
      return '+916364465607';
    } else {
      return `+91${finalContactSupportNumber}`;
    }
  };

  const getLabelForCall = (platformName: string) => {
    if (platformName === 'FREO') {
      return '63644 65607';
    } else {
      return finalContactSupportNumber;
    }
  };

  const getContactNumberForWhatsapp = (platformName: string) => {
    switch (platformName) {
      case FREO:
        return '916364465607';
      case SDK_INVESTWELL:
        return '917795402425';
      default:
        return `${whatsAppSupportNumber}`;
    }
  };

  const isFromInvestWellSDK = isPartnerPlatform && platform === SDK_INVESTWELL;
  const isFromPhonePe = isPartnerPlatform && platform === 'PHONEPE';
  const isFromNiyo = isPartnerPlatform && platform === NIYO;

  const viewHeightSmallToMedium = () => {
    switch (true) {
      case isFromInvestWellSDK:
        return dimensions.window.height - 28;
      case showHeader:
        return dimensions.window.height;
      default:
        return dimensions.window.height;
    }
  };

  const viewHeightMediumToLarge = () => {
    switch (true) {
      case showHeader:
        return dimensions.window.height - 114;
      default:
        return dimensions.window.height;
    }
  };

  const UniversalLogout = () => {
    clearAllData().then(async () => {
      document.cookie =
        `access_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;${window.location.protocol === 'https:' ? 'secure;' : ''}`;
      const showNewArch = await AsyncStorage.getItem('show_new_arch');
      setRoutingSupport(prevState => {
        return { ...prevState, renderNewArch: showNewArch === 'true' };
      });
      navigateWithReset(ROUTE.PHONE_NUMBER);
    });
    // callLogoutApi();
    accessToken = '';
    setModalVisible(false);
    LogOutUser();
  };

  const _renderLogoutConfirmationModal = (
    modalVisible: boolean,
    setModalVisible: Function,
  ) => (
    <Modal
      animationType={'fade'}
      transparent={true}
      visible={modalVisible}
      onRequestClose={() => {}}>
      <View
        style={{
          flex: 1,
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          height: '100%',
          backgroundColor: '#1D293966',
        }}>
        <View
          style={{
            backgroundColor: 'white',
            width: '70%',
            maxWidth: 508,
            height: '20%',
            borderRadius: 10,
            justifyContent: 'center',
            alignItems: 'center',
            borderColor: 'black',
            borderWidth: 2,
            padding: 10,
          }}>
          <Typography.Component
            label="Are you sure you want to logout?"
            color={ColorTokens.Grey_Charcoal}
            fontSize={FontSizeTokens.SM}
            fontFamily={FontFamilyTokens.Poppins}
            fontWeight="400"
            lineHeight={24}
            textAlign={TextAlignTokens.center}
          />
          <Space.Component size={SizeTypeTokens.MD} />
          <View
            style={{
              flexDirection: 'row',
              justifyContent: 'space-evenly',
              width: '100%',
              height: 35,
              alignItems: 'center',
            }}>
            <View
              style={{
                flexDirection: 'row',
                justifyContent: 'space-evenly',
                width: '100%',
              }}>
              <View
                style={{
                  width: 40,
                  height: 35,
                  alignItems: 'center',
                  justifyContent: 'center',
                }}>
                <TouchableOpacity onPress={UniversalLogout}>
                  <Typography.Component
                    label="Yes"
                    color={ColorTokens.Primary_100}
                    fontSize={FontSizeTokens.SM}
                    fontWeight="400"
                    lineHeight={18}
                  />
                </TouchableOpacity>
              </View>
              <View
                style={{
                  width: 40,
                  height: 35,
                  alignItems: 'center',
                  justifyContent: 'center',
                }}>
                <TouchableOpacity onPress={() => setModalVisible(false)}>
                  <Typography.Component
                    label="No"
                    color={ColorTokens.Primary_100}
                    fontSize={FontSizeTokens.SM}
                    fontWeight="400"
                    lineHeight={18}
                  />
                </TouchableOpacity>
              </View>
            </View>
          </View>
        </View>
      </View>
    </Modal>
  );

  const screenType = getScreenType(dimensions.window.width);
  const kycUrlRedirect = url?.includes('digilocker_referesh') || url?.includes('digilocker_refreshed');
  const initialRoute = takeToFlexiPay
  ? ROUTE.PAYMENT_START
  : isFromInvestWellSDK && !isCheckLimitMFC && !hideSKDIntroPage
  ? ROUTE.INTRO_PAGE
  : isPLJ
  ? ROUTE.PARTNER_LED_JOURNEY
  : isPgCallback && shouldRedirect
  ? ROUTE.PAYMENT_LOADER
  : isPgCallback
  ? ROUTE.PAYMENT_CALLBACK
  : digio_agreement_response
  ? ROUTE.DIGIO_AGREEMENT_SIGN
  : kyc_response && !losRevampConfig
  ? ROUTE.KYC_DIGIO_RESPONSE
  : tataMandateCallback && shouldRedirect && !losRevampConfig
  ? ROUTE.PAYMENT_LOADER
  : tataMandateCallback && !losRevampConfig
  ? ROUTE.DIGIO_MANDATE_SIGN 
  : digio_autopay_response && !losRevampConfig
  ? ROUTE.DIGIO_MANDATE_SIGN
  : digio_agreement_response && !losRevampConfig
  ? ROUTE.DIGIO_AGREEMENT_SIGN
  : isKYCRedirect
  ? ROUTE.KYC_DIRECT
  : kycUrlRedirect
  ? ROUTE.KYC_URL_REDIRECT
  : ROUTE.SPLASH_SCREEN;
  const RenderMF = useMemo(() => {
    const width =
      screenType === SCREEN_SIZE.X_SMALL || screenType === SCREEN_SIZE.SMALL
        ? dimensions.window.width
        : 508;
    const height =
      screenType === SCREEN_SIZE.X_SMALL || screenType === SCREEN_SIZE.SMALL
        ? viewHeightSmallToMedium()
        : viewHeightMediumToLarge();
    const kycUrlRedirect = url?.includes('digilocker_referesh') || url?.includes('digilocker_refreshed');
    const initialRoute = takeToFlexiPay
    ? ROUTE.PAYMENT_START
    : isFromInvestWellSDK && !isCheckLimitMFC && !hideSKDIntroPage
    ? ROUTE.INTRO_PAGE
    : isPLJ
    ? ROUTE.PARTNER_LED_JOURNEY
    : isPgCallback && shouldRedirect
    ? ROUTE.PAYMENT_LOADER
    : isPgCallback
    ? ROUTE.PAYMENT_CALLBACK
    : digio_agreement_response
    ? ROUTE.DIGIO_AGREEMENT_SIGN
    : kyc_response && !losRevampConfig
    ? ROUTE.KYC_DIGIO_RESPONSE
    : tataMandateCallback && shouldRedirect && !losRevampConfig
    ? ROUTE.PAYMENT_LOADER
    : tataMandateCallback && !losRevampConfig
    ? ROUTE.DIGIO_MANDATE_SIGN 
    : digio_autopay_response && !losRevampConfig
    ? ROUTE.DIGIO_MANDATE_SIGN
    : digio_agreement_response && !losRevampConfig
    ? ROUTE.DIGIO_AGREEMENT_SIGN
    : isKYCRedirect
    ? ROUTE.KYC_DIRECT
    : kycUrlRedirect
    ? ROUTE.KYC_URL_REDIRECT
    : ROUTE.SPLASH_SCREEN;
    if (isCgtc) {
      return (
        <>
          <MicroFrontend
            routeMap={ROUTE_MAP}
            routeCurrent={routingSupport.routeName || ROUTE.CGTC_INIT}
            widgetRegistry={WidgetRegistry}
            extraProps={{ setRoutingSupport, routingSupport,isNewArch }}
            width={
              screenType === SCREEN_SIZE.X_SMALL ||
              screenType === SCREEN_SIZE.SMALL
                ? dimensions.window.width
                : 640
            }
            //@ts-ignore
            height={isIframe || isMarketing ? boxHeight : height}
          />
        </>
      );
    }

    return (
      <>
        {isPgCallback && shouldRedirect ? null : (
          <StatusBar hidden={true} backgroundColor={'transparent'} />
        )}
        <MicroFrontend
          routeMap={ROUTE_MAP}
          routeCurrent={routingSupport.routeName || initialRoute}
          widgetRegistry={WidgetRegistry}
          extraProps={{
            setIsUserLoggedIn,
            isPgCallback,
            tataMandateCallback,
            skipToStep,
            isFromNativeSDK,
            setApplicationState,
            setShowSupportPhoneNumber,
            setRoutingSupport,
            routingSupport,
            isNewArch,
          }}
          width={width}
          //@ts-ignore
          height={isIframe || isMarketing ? boxHeight : height}
        />
      </>
    );
  },[screenType, dimensions.window.width, dimensions.window.height,routingSupport.renderNewArch])

  const PageNotFoundScreen = useMemo(() => {
    return <PageNotFound onPress={() => {}} />;
  }, []);

  const _renderAppbarWeb = useMemo(() => {
    return (
      <View
        style={{
          height: 60,
          width: '100%',
          backgroundColor: '#ffffff',
          marginBottom: 24,
          padding: 40,
          paddingTop: 20,
          paddingBottom: 20,
          alignItems: isFromInvestWellSDK ? 'center' : 'flex-end',
          flexDirection: 'row',
          justifyContent: isFromInvestWellSDK ? 'flex-end' : 'space-between',
        }}>
        {isFromInvestWellSDK ? null : (
          <Image
            style={{ width: 64, height: 24 }}
            source={{
              uri:
                showDefaultVoltLogo === 'false'
                  ? customLogoUrl
                  : 'https://volt-images.s3.ap-south-1.amazonaws.com/volt-website-header.svg',
            }}
          />
        )}

        <View
          style={{
            flexDirection: 'row',
            alignItems: 'center',
          }}>
          <Typography.Component
            label="Need help? "
            color={ColorTokens.Grey_Night}
            fontSize={FontSizeTokens.SM}
            fontWeight="400"
            lineHeight={18}
          />
          {isFromInvestWellSDK ? null : (
            <Space.Component size={SizeTypeTokens.XL} />
          )}
          {isFromInvestWellSDK || !showSupportPhoneNumber ? null : (
            <TouchableOpacity
              onPress={() => {
                track('HEADER_CALL_BUTTON_CLICKED');
                window.open(
                  finalContactSupportNumber
                    ? `tel:${finalContactSupportNumber}`
                    : `tel:${getContactNumberForCall(platform)}`,
                  '_parent',
                );
              }}>
              <Stack.Component type={StackType.row} width={StackWidth.CONTENT}>
                <Icon.Component name={IconTokens.Phone} />
                <Space.Component size={SizeTypeTokens.Size6} />
                <Typography.Component
                  label={
                    phoneNumber?phoneNumber :  finalContactSupportNumber
                      ? finalContactSupportNumber
                      : getLabelForCall(platform)
                  }
                  fontSize={FontSizeTokens.SM}
                  fontWeight={'500'}
                  lineHeight={20}
                  color={ColorTokens.Primary_100}
                />
              </Stack.Component>
            </TouchableOpacity>
          )}
          {isFromInvestWellSDK || !showSupportPhoneNumber ? (
            <Space.Component size={SizeTypeTokens.SM} />
          ) : (
            <Space.Component size={SizeTypeTokens.XL} />
          )}
          <TouchableOpacity
            onPress={() => {
              track('HEADER_WA_BUTTON_CLICKED');
              if (isFrm()) {
                window.open(
                  `https://wa.me/${getContactNumberForWhatsapp(platform)}`,
                  '_blank',
                );
              } else {
                window.open(
                  `https://api.whatsapp.com/send?phone=${getContactNumberForWhatsapp(
                    platform,
                  )}`,
                );
              }
            }}>
            <Stack.Component type={StackType.row} width={StackWidth.CONTENT}>
              <Icon.Component name={IconTokens.Whatsapp} />
              {isFromInvestWellSDK ? (
                <Space.Component size={SizeTypeTokens.SM} />
              ) : (
                <Space.Component size={SizeTypeTokens.Size6} />
              )}
              {isFromInvestWellSDK ? (
                <Typography.Component
                  label="WhatsApp us"
                  fontSize={FontSizeTokens.SM}
                  fontWeight={'600'}
                  lineHeight={20}
                  color={ColorTokens.Primary_100}
                />
              ) : (
                <Typography.Component
                  label="Chat with us"
                  fontSize={FontSizeTokens.SM}
                  fontWeight={'500'}
                  lineHeight={20}
                  color={ColorTokens.Primary_100}
                />
              )}
            </Stack.Component>
          </TouchableOpacity>

          {token == '' ? (
            <></>
          ) : (
            <>
              {isFromInvestWellSDK || showLogout == false ? null : (
                <>
                  <Space.Component size={SizeTypeTokens.XL} />
                  <TouchableOpacity
                    onPress={() => {
                      track('LOGOUT_BUTTON_CLICKED', { source: 'header' });
                      toggleModal();
                    }}>
                    <Stack.Component
                      type={StackType.row}
                      width={StackWidth.CONTENT}>
                      <Icon.Component name={IconTokens.Logout} />
                      <Space.Component size={SizeTypeTokens.Size6} />
                      <Typography.Component
                        label={'Logout'}
                        fontSize={FontSizeTokens.SM}
                        fontWeight={'500'}
                        lineHeight={20}
                        color={ColorTokens.Primary_100}
                      />
                      {name === null || name === '' ? (
                        <Typography.Component
                          label={''}
                          fontSize={FontSizeTokens.SM}
                          fontWeight={'500'}
                          lineHeight={20}
                          color={ColorTokens.Primary_100}
                        />
                      ) : (
                        <Typography.Component
                          label={`, ${name}`}
                          fontSize={FontSizeTokens.SM}
                          fontWeight={'500'}
                          lineHeight={20}
                          color={ColorTokens.Primary_100}
                        />
                      )}
                    </Stack.Component>
                  </TouchableOpacity>
                </>
              )}
            </>
          )}
        </View>
      </View>
    );
  }, [token, name, platform, getContactNumberForCall, isUserLoggedIn]);
  const _renderAppBarMobile = useMemo(() => {
    return (
      <View
        style={{
          height: isFromInvestWellSDK ? 28 : 64,
          backgroundColor: '#ffffff',
          alignItems: 'center',
          justifyContent: isFromInvestWellSDK ? 'flex-end' : 'space-between',
          paddingHorizontal: 16,
          paddingTop: isFromInvestWellSDK ? 6 : 0,
          flexDirection: 'row',
          width: '100%',
        }}>
        {isFromInvestWellSDK ? null : (
          <Image
            style={{ width: isFromNiyo ? 80 : 64, height: 24 }}
            source={{
              uri:
                showDefaultVoltLogo === 'false'
                  ? customLogoUrl
                  : 'https://volt-images.s3.ap-south-1.amazonaws.com/volt-website-header.svg',
            }}
          />
        )}

        <View
          style={{
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
          {!isFromPhonePe && (
            <Typography.Component
              label="Need help? "
              color={ColorTokens.Grey_Night}
              fontSize={FontSizeTokens.XS}
              fontWeight="400"
              lineHeight={18}
            />
          )}
          {isFromInvestWellSDK || isFromPhonePe ? null : (
            <Space.Component size={SizeTypeTokens.XL} />
          )}
          {isFromInvestWellSDK ||
          isFromPhonePe ||
          !showSupportPhoneNumber ? null : (
            <TouchableOpacity
              onPress={() =>
                window.open(
                  finalContactSupportNumber
                    ? `tel:${finalContactSupportNumber}`
                    : `tel:${getContactNumberForCall(platform)}`,
                  '_parent',
                )
              }>
              <Stack.Component type={StackType.row} width={StackWidth.CONTENT}>
                <Icon.Component name={IconTokens.Phone} />
                <Space.Component size={SizeTypeTokens.Size6} />
                <Typography.Component
                  label={
                    finalContactSupportNumber
                      ? finalContactSupportNumber
                      : getLabelForCall(platform)
                  }
                  fontSize={FontSizeTokens.SM}
                  fontWeight={'500'}
                  lineHeight={20}
                  color={ColorTokens.Primary_100}
                />
              </Stack.Component>
            </TouchableOpacity>
          )}
          {isFromInvestWellSDK || isFromPhonePe || !showSupportPhoneNumber ? (
            <Space.Component size={SizeTypeTokens.SM} />
          ) : (
            <Space.Component size={SizeTypeTokens.XL} />
          )}
          {!isFromPhonePe && (
            <TouchableOpacity
              onPress={() => {
                if (platform === 'PHONEPE') {
                  window.open(
                    'whatsapp://send?phone=+919611749097&text=Hi',
                    '_parent',
                  );

                  return;
                }

                if (isFrm()) {
                  window.open(
                    `https://wa.me/${getContactNumberForWhatsapp(platform)}`,
                    '_blank',
                  );
                  return;
                }

                if (Platform.OS === 'web') {
                  window.open(
                    `whatsapp://send?phone=${getContactNumberForWhatsapp(
                      platform,
                    )}`,
                    '_parent',
                  );
                } else {
                  Linking.openURL(
                    `whatsapp://send?phone=${getContactNumberForWhatsapp(
                      platform,
                    )}`,
                  )
                    .then(data => {
                      console.log('WhatsApp Opened successfully ' + data);
                    })
                    .catch(() => {
                      console.log('WhatsApp not installed in the device');
                    });
                }
              }}>
              <Icon.Component
                name={IconTokens.Whatsapp}
                size={IconSizeTokens.XXL}
              />
            </TouchableOpacity>
          )}
          {token == '' ? (
            <></>
          ) : (
            <>
              {isFromInvestWellSDK || showLogout == false ? null : (
                <>
                  <Space.Component size={SizeTypeTokens.XL} />
                  <TouchableOpacity onPress={() => toggleModal()}>
                    <Icon.Component
                      name={IconTokens.Logout}
                      color={ColorTokens.Primary_100}
                      size={IconSizeTokens.XL}
                    />
                  </TouchableOpacity>
                </>
              )}
            </>
          )}
        </View>
      </View>
    );
  }, [token, name, toggleModal]);

  const renderApp = useMemo(() => {
    const height =
      screenType === SCREEN_SIZE.X_SMALL || screenType === SCREEN_SIZE.SMALL
        ? viewHeightSmallToMedium()
        : viewHeightMediumToLarge();
    const myroutes = [ROUTE.SPLASH_SCREEN,ROUTE.PARTNER_LED_JOURNEY,ROUTE.PHONE_NUMBER,ROUTE.INTRO_PAGE]
    if (routingSupport.renderNewArch && myroutes.includes(initialRoute) && !isCgtc && !isCheckLimitMFC) {
      const isSmallScreen = dimensions.window.width < 767;
      return (
        <View
          style={{
            marginBottom: isSmallScreen ? 0 : 30,
            height,
            minHeight: isKeyboardVisible ? '90vh' : 'auto',
          }}>
          <NewApp
            extraProps={{
              routingSupport,
              setRoutingSupport,
              setIsUserLoggedIn,
              startWithOldArch : startWithOldArch
            }}
          />
        </View>
      );
    } else {
      return RenderMF ;
    }
  }, [
    routingSupport.renderNewArch,
    token,
    dimensions.window.width,
    dimensions.window.height,
    initialRoute
  ]);
  // console.log('screenType', screenType);
  switch (screenType) {
    case SCREEN_SIZE.X_SMALL:
    case SCREEN_SIZE.SMALL: {
      return (
        <SafeAreaView style={{ flex: 1}}>
          {!isCheckLimitMFC && showHeader ? (
            <>
              {_renderLogoutConfirmationModal(modalVisible, setModalVisible)}
              {/* {_renderAppBarMobile} */}
            </>
          ) : (
            <View />
          )}
          {/* <NewApp extraProps={{routingSupport,setRoutingSupport}} />; */}

          {isFreo ? PageNotFoundScreen : renderApp}
        </SafeAreaView>
      );
    }
    case SCREEN_SIZE.MEDIUM:
    case SCREEN_SIZE.LARGE:
    case SCREEN_SIZE.X_LARGE: {
      return (
        <View
          style={{
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: '#F2F2F2',
            height: '100%',
            width: '100%',
          }}>
          {showHeader ? (
            <>
              {_renderLogoutConfirmationModal(modalVisible, setModalVisible)}
              {_renderAppbarWeb}
            </>
          ) : (
            <View />
          )}
          <View
            style={{
              height: showHeader
                ? dimensions.window.height - 84
                : dimensions.window.height,
              width: isCgtc ? 640 : 508,
              overflow: 'hidden',
            }}>
            {/* <NewApp extraProps={{routingSupport,setRoutingSupport}} />; */}

            {isFreo ? PageNotFoundScreen : renderApp}
          </View>
        </View>
      );
    }
  }
};

export default Platform.OS === 'web' ? AppWeb : Sentry.wrap(AppWeb);
